import { $api } from "../generated/client";
import type { UseReturnRequestsQueryOptions } from "./use-return-requests";

export default function useReturnRequestsOnce({
	shopId,
	search,
	sortBy,
	sortOrder,
	filter,
	quickFilter,
	page,
}: UseReturnRequestsQueryOptions) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/return-requests/cursor",
		{
			params: {
				path: { shopId },
				query: {
					search: search || "noop",
					sortBy,
					sortOrder,
					quickFilter,
					page: page || 1,
					statusCondition: filter?.status?.condition,
					statusValue: filter?.status?.value,
					reasonCondition: filter?.reason?.condition,
					reasonValue: filter?.reason?.value,
					countryCondition: filter?.country?.condition,
					countryValue: filter?.country?.value,
					assigneeCondition: filter?.assignee?.condition,
					assigneeValue: filter?.assignee?.value,
					createdDateCondition: filter?.createdDate?.condition,
					createdDateValue: filter?.createdDate?.value,
					resolutionCondition: filter?.resolution?.condition,
					resolutionValue: filter?.resolution?.value,
					returnStoreCondition: filter?.returnStore?.condition,
					returnStoreValue: filter?.returnStore?.value,
				},
			},
		},
		{
			enabled: !!search?.length,
			retry: false,
			retryOnMount: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		},
	);
}
